import React, {Component, PropTypes} from 'react'
import _ from 'lodash';
import  '../../assets/styles/animate.css';
import DublicateProject from '../../components/Toolkit/DublicateProject/DublicateProject';

class DropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownToggle: false,
      dublicateContent: false,
      modalOpen: false,
    }
  }

  openDropDown = () => {
    if(this.state.dropDownToggle){
      this.setState({ dropDownToggle: false})
    }else{
      this.setState({ dropDownToggle: true})
    }
  }

  onBlur = () => {
    setTimeout(() => {
      this.setState({dropDownToggle: false});
  }, 100);

  }

  dublicateProject = () => {
    this.setState({ dublicateContent: true })
  }

  dropDownClick = e => {
    e.stopPropagation();

  }

  openModal = () => {
    this.setState({ modalOpen: !this.state.modalOpen })
  }

  render() {
    return (
      <div className="dropdown-box" onClick={this.dropDownClick}>
        <div className="cog-box" onClick={ () => this.openDropDown() } tabIndex="0" >
            <i className="fa fa-cog" aria-hidden="true"></i>
        </div>
        { (this.state.dropDownToggle) &&
          <div className={this.state.dropDownToggle ? 'animated fadeDown settings-box' : 'animated fadeUp settings-box' }>
            <ul>
              <li onClick={ () => this.dublicateProject()}> <i className="far fa-copy" aria-hidden="true"></i> Duplicate </li>
              { this.state.dublicateContent &&
                <li className='dublicate-list'>
                  <DublicateProject
                    deleteProject={this.props.deleteProject}
                    openDropDown={this.openDropDown}
                    dublicateProject={this.props.dublicateProject}
                    dublicateData={this.props.dublicateData}
                    getProjectsList={this.props.getProjectsList}
                    projectData={this.props.projectData}
                  />

                </li>
              }

              <li
                onClick={ this.openModal }
              >
                <i className="far fa-trash-alt" aria-hidden="true"></i> Delete
              </li>
            </ul>
          </div>
        }
        {this.state.modalOpen &&
            <div className='opacity-overlay ' style={{'display': 'block'}}>
                <div className="container">
                    <div className="popup-wrapper">
                        <div className="col-xs-12 col-sm-4 popup-content">
                          <div>
                              <div className='modal-header'>
                                  <h5>Delete Project</h5>
                              </div>
                              <div className='modal-body'>
                                  <p>Are you sure you want to delete this project ?</p>

                                  <div
                                      onClick={this.openModal }
                                      className="btn btn-cancel">
                                          No
                                  </div>
                                  <div
                                      onClick={ () => this.props.deleteProject(this.props.projectData.projectId) }
                                      className="btn btn-cancel">
                                          Yes
                                  </div>
                              </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        }

      </div>
    );
  }

}
export default (DropDown);



// WEBPACK FOOTER //
// ./src/shared/Common/dropDown.jsx